export default __webpack_public_path__ + "static/garamond-medium-f1e0ea5257ce7b50bf0ea8c7f35ceb13.ttf";